import { createSelector } from 'reselect'
import { TagType, constants } from './constants'

const root = state => state.get('tags')
export const tags = createSelector(root, root => root && root.get('data'))
export const status = createSelector(root, root => root && root.get('status'))
export const tag = (state, { tagId }) => root(state) && root(state).getIn(['data', tagId])
export const conversationTags = createSelector(tags, tags =>
  tags.valueSeq().filter(tag => tag.targetType === TagType.CONVERSATION),
)
export const customerTags = createSelector(tags, tags =>
  tags.valueSeq().filter(tag => tag.targetType === TagType.ANY),
)
export const tagsFetchStatus = createSelector(status, status => status && status.getIn(['tags', 'fetch']))
export const isLoaded = createSelector(tagsFetchStatus, tagsFetchStatus => tagsFetchStatus === constants.RECEIVE_TAG_LIST)
export const isLoading = createSelector(tagsFetchStatus, tagsFetchStatus => tagsFetchStatus === constants.FETCH_TAG_LIST_PENDING)
export const tagUpdateStatus = createSelector(status, status => status && status.getIn(['tag', 'update']))



// WEBPACK FOOTER //
// ./src/scripts/app/modules/tags/selectors.js